<template>
	<div class="bg-white px-3 index" style="margin: 0 26px;margin-bottom: 0!important;">

		<div class="py-2 border-bottom d-flex align-items-center">
			<el-button type="primary" size="mini" @click="__init">搜索</el-button>
			<el-button type="primary" size="mini" @click="createTop">创建顶级分类</el-button>
		</div>
		<el-tree :data="data" :props="defaultProps" @node-click="handleNodeClick" default-expand-all
			:expand-on-click-node="false" draggable @node-drop="nodeDrop" @node-drag-end="nodeDragEnd">

			<span class="custom-tree-node" slot-scope="{ node, data }">
				<div>
					<el-input v-if="data.editStatus" v-model="data.name" size="mini"></el-input>
					<span v-else>{{ node.label }}</span>
				</div>
				<span>
					<span v-if="data.category_id==0" style="margin-right:20px">{{({1:'快康',2:'正汉'})[data.data_source]}}</span>
					<el-button :type="data.status ? 'primary' : 'danger'" size="mini" @click.stop="showOrHide(data)">
						{{data.status ? '显示' : '隐藏'}}
					</el-button>
					<el-button type="success" size="mini" @click="append(data)">增加</el-button>
					<el-button type="warning" size="mini" @click="edit(data)">修改</el-button>
					<el-button type="danger" size="mini" @click="remove(node,data)">删除</el-button>
				</span>
			</span>

		</el-tree>

		<el-dialog title="分类设置" :visible.sync="dialogVisible" center width="40%" class="dialogs">
			<el-divider></el-divider>
			<div class="dialog-ibox-content">
				<el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="150px">
					<el-form-item label="分类" prop="name">
						<el-input v-model="ruleForm.name" size="mini"></el-input>
					</el-form-item>
					<el-form-item label="参数" prop="link">
						<el-input v-model="ruleForm.link" size="mini"></el-input>
					</el-form-item>
					<el-form-item label="展示平台" v-if="category_id==0">
						<el-radio-group v-model="ruleForm.data_source">
							<el-radio :label="1" border>快康</el-radio>
							<el-radio :label="2" border>正汉</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="图标">
						<el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="uploadIcon"
							:headers="{ 'token':$store.state.user.token }" :data="{ image_class_id:'78',file_type:'1'}"
							:file-list="ruleForm.icon_mapList" :on-success="uploadSuccessIcon" :limit="1"
							:on-remove="uploadRmoveIcon" list-type="picture-card">
							<i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
					<el-form-item label="背景图">
						<el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload"
							:headers="{ 'token':$store.state.user.token }" :data="{ image_class_id:'78',file_type:'1'}"
							:file-list="ruleForm.lb_mapList" :on-success="uploadSuccess" :limit="1"
							:on-remove="uploadRmove" list-type="picture-card">
							<i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
				</el-form>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button @click="submit('ruleForm')" size="small" type="primary" :loading="subloading">确 认</el-button>
				<el-button @click="dialogVisible = false" size="small">取 消</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	export default {
		inject: ['layout'],
		data() {
			return {
				data: [],
				defaultProps: {
					children: 'child',
					label: 'name'
				},
				// 
				zindex: '',
				objxx: '',
				dialogVisible: false,
				subloading: false,
				ruleForm: {
					name: '',
					link: '',
					icon_mapList: [],
					lb_mapList: [],
					data_source:1
				},
				mapListIcon: [],
				mapListed: [],
				rule: {
					name: [{
						required: true,
						message: '请填写分类',
						trigger: 'blur'
					}],
					link: [{
						required: true,
						message: '请填写参数',
						trigger: 'blur'
					}],
				},
				category_id:0,
			};
		},
		created() {
			this.__init()
		},
		computed: {
			// 排序后的数据
			sortData() {
				let data = []
				let sort = function (arr) {
					arr.forEach(item => {
						data.push(item)
						if (item.child.length) {
							sort(item.child)
						}
					})
				}
				// 多维数组转一维数组
				sort(this.data)
				// 排序
				data = data.map((item, index) => {
					return {
						id: item.id,
						order: index,
						category_id: item.category_id
					}
				})
				return data
			}
		},
		methods: {
			// 初始化
			__init() {
				this.layout.showLoading()
				this.axios.get('/admin/category', {
					token: true
				}).then(res => {
					let data = res.data.data
					let addEditStatus = function (arr) {
						arr.forEach(item => {
							item.editStatus = false
							if (item.child.length) {
								addEditStatus(item.child)
							}
						})
					}
					addEditStatus(data)
					this.data = data
					this.layout.hideLoading()
				}).catch(err => {
					this.layout.hideLoading()
				})
			},
			handleNodeClick(data) {},
			// 显示/隐藏
			showOrHide(data) {
				this.layout.showLoading()
				let status = data.status ? 0 : 1
				let msg = status ? '显示' : '隐藏'
				this.axios.post('/admin/category/' + data.id + '/update_status', {
					status
				}, {
					token: true
				}).then(res => {
					data.status = status
					this.layout.hideLoading()
					this.$message({
						message: msg + '成功',
						type: 'success'
					});
				}).catch(err => {
					this.layout.hideLoading()
				})
			},

			// 删除
			remove(node, data) {
				this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
					confirmButtonText: '删除',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.layout.showLoading()
					axios.delete('/admin/category/' + data.id, {
						token: true
					}).then(res => {
						this.__init()
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						this.layout.hideLoading()
					}).catch(err => {
						this.layout.hideLoading()
					})
				})

			},
			// 增加子分类
			append(data) {
				this.ruleForm.data_source =data.data_source
				this.category_id=1 //添加子分类不显示
				this.zindex = 3
				this.dialogVisible = true
				this.ruleForm.icon_mapList = []
				this.mapListIcon = []
				this.ruleForm.lb_mapList = []
				this.mapListed = []
				this.ruleForm.name = ''
				this.ruleForm.link = ''
				this.objxx = data
			},
			// 拖拽结束
			nodeDragEnd(...options) {
				// 被拖拽节点对应的数据
				let item = options[0].data
				// 结束拖拽时最后进入的节点数据
				let obj = options[1].data
				if (obj) {
					if (options[2] === 'before' || options[2] === "after") {
						item.category_id = obj.category_id
					} else {
						item.category_id = obj.id
					}
				}
			},
			// 拖拽
			nodeDrop(...options) {
				this.layout.showLoading()
				this.axios.post('/admin/category/sort', {
					sortdata: JSON.stringify(this.sortData)
				}, {
					token: true
				}).then(res => {
					this.__init()
					this.layout.hideLoading()
				}).catch(err => {
					this.layout.hideLoading()
				})
			},
			// 创建顶级分类
			createTop() {
				this.category_id=0
				this.zindex = 1
				this.dialogVisible = true
				this.ruleForm.lb_mapList = []
				this.mapListed = []
				this.ruleForm.name = ''
				this.ruleForm.link = ''
				this.ruleForm.data_source = 1
				this.ruleForm.icon_mapList = []
				this.mapListIcon = []
				this.objxx = ''
			},
			submit(formName) {
				let that = this
				that.$refs[formName].validate((valid) => {
					if (valid) {
						that.subloading = true
						if (this.zindex == 1) {
							var urls = '/admin/category'
							var status = 0
							var category_id = 0
						} else if (this.zindex == 2) {
							var urls = '/admin/category/' + this.objxx.id
							var status = this.objxx.status
							var category_id = this.objxx.category_id
						} else {
							var urls = '/admin/category'
							var status = 0
							var category_id = this.objxx.id
						}
						axios.post(urls, {
								status: status,
								category_id: category_id,
								name: this.ruleForm.name,
								file_info: this.mapListed,
								icon: this.mapListIcon,
								link: this.ruleForm.link,
								data_source: this.ruleForm.data_source
							}, {
								token: true
							})
							.then(response => {
								that.subloading = false
								that.dialogVisible = false
								that.__init()
							})
							.catch(error => {
								that.subloading = true
							})
					} else {
						this.$alert("信息遗漏未填")
						return false;
					}
				});
			},
			// 编辑|提交
			edit(data) {
				this.zindex = 2
				this.category_id=data.category_id
				this.dialogVisible = true
				this.ruleForm.lb_mapList = []
				this.ruleForm.name = ''
				this.mapListed = []
				this.objxx = ''
				this.objxx = data
				this.ruleForm.name = data.name
				this.ruleForm.link = data.link
				this.ruleForm.data_source = data.data_source
				this.mapListed = data.file_info ? data.file_info : []
				this.ruleForm.lb_mapList = data.file_info ? data.file_info : []
				this.mapListIcon = data.icon ? data.icon : []
				this.ruleForm.icon_mapList = data.icon ? data.icon : []
			},
			// 
			uploadSuccessIcon(response, file, fileList) {
				let that = this
				if (response.code == "201") {
					that.$nextTick(() => {
						let mainImg = that.$refs.uploadIcon;
						if (mainImg) {
							mainImg.uploadFiles.forEach((element, index) => {
								if (file.uid == element.uid) {
									mainImg.uploadFiles.splice(index, 1)
								}
							});
						}
					})
					that.$alert(response.msg)
					return;
				}
				that.$message({
					message: '上传成功',
					type: 'success'
				});
				that.mapListIcon.push(response.data)
			},
			uploadRmoveIcon(file, fileList) {
				this.mapListIcon = []
			},
			// 
			uploadSuccess(response, file, fileList) {
				let that = this
				if (response.code == "201") {
					that.$nextTick(() => {
						let mainImg = that.$refs.upload;
						if (mainImg) {
							mainImg.uploadFiles.forEach((element, index) => {
								if (file.uid == element.uid) {
									mainImg.uploadFiles.splice(index, 1)
								}
							});
						}
					})
					that.$alert(response.msg)
					return;
				}
				that.$message({
					message: '上传成功',
					type: 'success'
				});
				that.mapListed.push(response.data)
			},
			uploadRmove(file, fileList) {
				this.mapListed = []
			},

		}
	}
</script>

<style lang='scss' scoped>
	.index {
		border-radius: 6px;
		padding-bottom: 10px;
	}

	.custom-tree-node {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 14px;
		padding-right: 8px;
	}

	.el-tree-node__content {
		padding: 20px 0;
	}
</style>